import { adminRoutes } from 'app/constants/routes';
import { UserRoles } from 'app/constants/user';
import { RouteBuilderItem } from 'app/routes/routeBuilder';

import {
  FactorDebtorMatchingDashboard,
  FactorDebtorMatchingNext,
  FactorDebtorMatchingShow,
} from './FactorDebtorMatchingRouteComponents';

const basePath = adminRoutes.factorDebtorMatchings;

export const factorDebtorMatchingRoutes: RouteBuilderItem[] = [
  /* eslint-disable @typescript-eslint/naming-convention */
  {
    Component: FactorDebtorMatchingDashboard,
    path: `${basePath}/dashboard`,
    permitOnly: [UserRoles.CarrierConnector],
  },
  {
    Component: FactorDebtorMatchingNext,
    path: `${basePath}/next`,
    permitOnly: [UserRoles.CarrierConnector],
  },
  {
    Component: FactorDebtorMatchingShow,
    path: `${basePath}/:id`,
    permitOnly: [UserRoles.CarrierConnector],
  },
  /* eslint-enable @typescript-eslint/naming-convention */
];
